import { createContext, useContext, useEffect } from "react";

const ReferralContext = createContext(null);

export function ReferralProvider({ children }) {
  useEffect(() => {
    const url = new URL(window.location.href);
    const ref = url.searchParams.get("ref");
    if (ref && /^[A-Z0-9]{6,10}$/.test(ref.toUpperCase())) {
      localStorage.setItem("nx_ref", ref.toUpperCase());
      localStorage.setItem("nx_ref_ts", String(Date.now()));
    }
  }, []);
  const value = { getRef: () => localStorage.getItem("nx_ref") };
  return <ReferralContext.Provider value={value}>{children}</ReferralContext.Provider>;
}

export const useReferral = () => useContext(ReferralContext);
